import {
  waitlistStatusLabel,
  type AccessGateAccent,
} from '@francisquiniai/cuidari-core/auth'
import type { WaitlistMe } from '@/lib/waitlist/peitho-client'
import { icon } from './shared'

export function WaitlistStatusCard({
  me,
  loading,
  onRefresh,
}: {
  me: WaitlistMe | null
  loading: boolean
  onRefresh: () => void
}) {
  return (
    <section className="login-card login-card--status" data-testid="waitlist-status-card">
      <p className="login-kicker">sua entrada na fila</p>
      <h2>Você já tem um lugar guardado</h2>
      <p className="login-card__body">
        Estamos cuidando da sua vez. Quando a próxima onda abrir, você recebe o
        aviso pelo canal da fila.
      </p>
      <div className="login-detail-grid">
        <AccessDetail
          iconName="confirmation_number"
          label="posição"
          value={me?.position ? `#${me.position}` : '—'}
          accent="teal"
        />
        <AccessDetail
          iconName="groups"
          label="à frente"
          value={me ? String(me.ahead) : '—'}
          accent="amber"
        />
        <AccessDetail
          iconName="event_available"
          label="situação"
          value={waitlistStatusLabel(me?.status)}
          accent="slate"
        />
      </div>
      <button
        type="button"
        className="login-button login-button--primary"
        onClick={onRefresh}
        disabled={loading}
      >
        {loading && <span className="login-spinner" aria-hidden="true" />}
        <span>{loading ? 'Verificando…' : 'Verificar minha posição'}</span>
      </button>
    </section>
  )
}

function AccessDetail({
  iconName,
  label,
  value,
  accent,
}: {
  iconName: string
  label: string
  value: string
  accent: AccessGateAccent
}) {
  return (
    <div className={`login-detail login-detail--${accent}`}>
      <span>{icon(iconName)}</span>
      <small>{label}</small>
      <strong>{value}</strong>
    </div>
  )
}

export function WaitlistStep({
  iconName,
  title,
  body,
  accent,
}: {
  iconName: string
  title: string
  body: string
  accent: AccessGateAccent
}) {
  return (
    <div className={`login-step login-step--${accent}`}>
      <span>{icon(iconName)}</span>
      <div>
        <strong>{title}</strong>
        <p>{body}</p>
      </div>
    </div>
  )
}
